import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import {
  APPLICATION_DETAILS,
  OTHER_APPLICATION_DETAILS,
  UTILITY_CONSUMER,
  UTILITY_CONSUMER_METER,
} from "tagTypes";

export const useGetAvailableMetersQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/application/utility-consumer/available-meter",
    query,
    tags: [UTILITY_CONSUMER],
  });

export const useLazyGetAvailableMetersQuery = () => {
  const [getMeters, meters] = useLazyGetQuery();

  const getAvailableMeters = async (query) =>
    await getMeters({
      endpoint: "/application/utility-consumer/available-meter",
      query,
      tags: [UTILITY_CONSUMER_METER],
    }).unwrap();
  return [getAvailableMeters, meters];
};

export const useGetConsumerMeterDetailsByConsumerId = (consumerId) =>
  useGetQuery({
    endpoint: `/meter/utility-consumer/${consumerId}`,
    tags: [UTILITY_CONSUMER],
  });

export const useGetConsumerOtherMeterDetailsByConsumerId = (consumerId) =>
  useGetQuery({
    endpoint: `/other-utility-meter/utility-consumer/${consumerId}`,
    tags: [UTILITY_CONSUMER],
  });

export const useGetMeterDetailsByMeterId = (meterId, query = {}) =>
  useGetQuery({
    endpoint: `/meter/${meterId}`,
    query,
    tags: [UTILITY_CONSUMER],
  });

export const useLazyGetMeterDetailsByMeterId = () => {
  const [getMeterDetails, meterDetails] = useLazyGetQuery();
  const getMeterDetailsByMeterId = async (meterId) =>
    await getMeterDetails({
      endpoint: `/meter/${meterId}`,
      tags: [UTILITY_CONSUMER_METER],
    }).unwrap();

  return [getMeterDetailsByMeterId, meterDetails];
};

export const useLazyGetMeterDetailsByTypeId = () => {
  const [getMeterDetails, meterDetails] = useLazyGetQuery();
  const getMeterDetailsByType = async (query = {}) =>
    await getMeterDetails({
      endpoint: "/meter-type",
      tags: [],
      query,
    }).unwrap();

  return [getMeterDetailsByType, meterDetails];
};

export const useGetMeterInfoByApplicationIdQuery = (applicationId) =>
  useGetQuery({
    endpoint: `/application/${applicationId}/meter`,
    tags: [UTILITY_CONSUMER_METER],
  });

export const useLazyGetMeterDetailsByApplicationId = () => {
  const [getMeterDetails, meterDetails] = useLazyGetQuery();
  const getMeterDetailsByMeterId = async (applicationId) =>
    await getMeterDetails({
      endpoint: `/application/${applicationId}/meter`,
      tags: [UTILITY_CONSUMER_METER],
    }).unwrap();
  return [getMeterDetailsByMeterId, meterDetails];
};

export const usePostMeterInfoMutation = () => {
  const [updateMeterInfo, meterInfo] = usePostMutation();
  const updateMeterInformation = async ({
    payload,
    query,
    toastMessage = "",
    tags = [],
  }) =>
    await updateMeterInfo({
      endpoint: "/application/meter",
      payload: payload || {},
      query,
      toastMessage,
      tags: [UTILITY_CONSUMER_METER, ...tags],
    }).unwrap();
  return [updateMeterInformation, meterInfo];
};

export const usePostSolarMeterInfoMutation = () => {
  const [updateMeterInfo, meterInfo] = usePostMutation();
  const updateMeterInformation = async ({
    payload,
    query,
    toastMessage = "",
    tags = [],
  }) =>
    await updateMeterInfo({
      endpoint: "/application/solar-meter",
      payload: payload || {},
      query,
      toastMessage,
      tags: [UTILITY_CONSUMER_METER, ...tags],
    }).unwrap();
  return [updateMeterInformation, meterInfo];
};

export const usePostOtherUtilityMeterInfoMutation = () => {
  const [updateMeterInfo, meterInfo] = usePostMutation();
  const updateMeterInformation = async ({
    payload,
    query,
    toastMessage = "",
  }) =>
    await updateMeterInfo({
      endpoint: "/application/other-utility-meter",
      payload: payload || {},
      query,
      toastMessage,
      tags: [OTHER_APPLICATION_DETAILS, APPLICATION_DETAILS, UTILITY_CONSUMER],
    }).unwrap();
  return [updateMeterInformation, meterInfo];
};
